import { Centre } from "request/objects/centre.js" // eslint-disable-line
import { Salarie } from "request/objects/salarie.js" // eslint-disable-line
import { TypeEnvoi } from "request/objects/typeEnvoi.js" // eslint-disable-line
import { TypeSanction } from "request/objects/typeSanction.js" // eslint-disable-line
import { File } from "./file"
import { Historique } from "./historique"

/**
 * Procedure Object
 */
export class Procedure {
    /**
     * @param {object} data
     * @param {number=} data.id
     * @param {number=} data.salId
     * @param {object=} data.sal
     * @param {number=} data.cenId
     * @param {object=} data.cen
     * @param {number=} data.salManagerId
     * @param {object=} data.salManager
     * @param {object=} data.salDirecteur
     * @param {number=} data.affecteeId
     * @param {object=} data.affectee
     * @param {string=} data.fait
     * @param {boolean=} data.avecMapConserv
     * @param {number=} data.typeSanEnvisageId
     * @param {object=} data.typeSanEnvisage
     * @param {string=} data.numRecConvoc
     * @param {string=} data.dateEnvoiConvoc
     * @param {string=} data.datePresentConvoc
     * @param {boolean=} data.avecLicenciement
     * @param {string=} data.dateEntretien
     * @param {string=} data.crDate
     * @param {string=} data.crLieu
     * @param {string=} data.crFait
     * @param {string=} data.crConsequence
     * @param {boolean=} data.crAReconnu
     * @param {boolean=} data.crEstAssiste
     * @param {number=} data.typeSanCrDecisionId
     * @param {object=} data.typeSanCrDecision
     * @param {number=} data.typeSanReelId
     * @param {object=} data.typeSanReel
     * @param {number=} data.typeEnvId
     * @param {object=} data.typeEnv
     * @param {string=} data.dateEnvoiSanction
     * @param {string=} data.dateReceptSanction
     * @param {number=} data.nbJourMap
     * @param {boolean=} data.estCloture
     * @param {string=} data.dateCreation
     * @param {string=} data.origineCreation
     * @param {string=} data.dateModif
     * @param {string=} data.origineModif
     * @param {number=} data.etape
     * @param {number=} data.crNbJourMap
     * @param {number=} data.typeEnvConvocId
     * @param {object=} data.typeEnvConvoc
     * @param {string=} data.numRecSanction
     * @param {string=} data.crNomAssistant
     * @param {string=} data.crPeriodeMap
     * @param {boolean=} data.estAvecDateEnt
     * @param {string=} data.convocComment
     * @param {string=} data.sancComment
     * @param {string=} data.dateFaits
     * 
     * @param {number=} data.procTypeEnvId
     * @param {string=} data.entretienAdresse
     * @param {string=} data.heureFaits
     * @param {string=} data.lieuFaits
     * @param {string=} data.missionFait
     * @param {boolean=} data.estMaterielle
     * @param {string=} data.materielle
     * @param {boolean=} data.estHumaine
     * @param {string=} data.humaine
     * @param {boolean=} data.estFinanciere
     * @param {string=} data.financiere
     * @param {boolean=} data.estTemoin
     * @param {string=} data.temoins
     * 
     * @param {boolean=} data.estFait2
     * @param {string=} data.dateFaits2
     * @param {string=} data.heureFaits2
     * @param {string=} data.lieuFaits2
     * @param {string=} data.fait2
     * @param {string=} data.missionFait2
     * @param {boolean=} data.estMaterielle2
     * @param {string=} data.materielle2
     * @param {boolean=} data.estHumaine2
     * @param {string=} data.humaine2
     * @param {boolean=} data.estFinanciere2
     * @param {string=} data.financiere2
     * @param {boolean=} data.estTemoin2
     * @param {string=} data.temoins2
     * 
     * @param {boolean=} data.estFait3
     * @param {string=} data.dateFaits3
     * @param {string=} data.heureFaits3
     * @param {string=} data.lieuFaits3
     * @param {string=} data.fait3
     * @param {string=} data.missionFait3
     * @param {boolean=} data.estMaterielle3
     * @param {string=} data.materielle3
     * @param {boolean=} data.estHumaine3
     * @param {string=} data.humaine3
     * @param {boolean=} data.estFinanciere3
     * @param {string=} data.financiere3
     * @param {boolean=} data.estTemoin3
     * @param {string=} data.temoins3
     * 
     * @param {number=} data.photoFile
     * @param {number=} data.releveVitessesFile
     * @param {number=} data.factureFile
     * @param {number=} data.accidentFile
     * @param {number=} data.mailFile
     * @param {number=} data.attestationsFile
     * 
     * @param {object[]=} data.file
     * 
     * @param {string=} data.creationDate
     * @param {string=} data.modifDate
     * @param {object[]=} data.historique
     * 
     * @param {string=} data.createur
     * 
     * @param {string=} data.salManuel
     * @param {string=} data.cenManuel
     * @param {string=} data.salManagerManuel
     * @param {string=} data.salMailManuel
     * @param {string=} data.salManagerMailManuel
     * @param {boolean=} data.estSaisieManuelle
     * 
     * @param {any=} data.acces
     * 
     * @param {string=} data.dateDistributionSanction
     * @param {string=} data.dateDistributionConvoc
     * 
     * @param {string=} data.rhDateDepart
     * @param {boolean=} data.rhEstVisibleReport
     * @param {string=} data.rhComment
     * 
     * @param {boolean=} data.repPers 
     */
    constructor({
        id = 0,
        salId = null,
        sal = null,
        cenId = null,
        cen = null,
        salManagerId = null,
        salManager = null,
        salDirecteur = null,
        affecteeId = null,
        affectee = null,
        fait = null,
        avecMapConserv = null,
        typeSanEnvisageId = null,
        typeSanEnvisage = null,
        numRecConvoc = null,
        dateEnvoiConvoc = null,
        datePresentConvoc = null,
        avecLicenciement = null,
        dateEntretien = null,
        crDate = null,
        crLieu = null,
        crFait = null,
        crConsequence = null,
        crAReconnu = null,
        crEstAssiste = null,
        typeSanCrDecisionId = null,
        typeSanCrDecision = null,
        typeSanReelId = null,
        typeSanReel = null,
        typeEnvId = null,
        typeEnv = null,
        dateEnvoiSanction = null,
        dateReceptSanction = null,
        nbJourMap = null,
        estCloture = false,
        dateCreation = null,
        origineCreation = null,
        dateModif = null,
        origineModif = null,
        etape = null,
        crNbJourMap = null,
        typeEnvConvocId = null,
        typeEnvConvoc = null,
        numRecSanction = null,
        crNomAssistant = null,
        crPeriodeMap = null,
        estAvecDateEnt = null,
        convocComment = null,
        sancComment = null,
        dateFaits = null,

        // ajouts

        procTypeEnvId = 0,
        entretienAdresse = null,
        heureFaits = null,
        lieuFaits = null,
        missionFait = null,
        estMaterielle = null,
        materielle = null,
        estHumaine = null,
        humaine = null,
        estFinanciere = null,
        financiere = null,
        estTemoin = null,
        temoins = null,

        estFait2 = null,
        dateFaits2 = null,
        heureFaits2 = null,
        lieuFaits2 = null,
        fait2 = null,
        missionFait2 = null,
        estMaterielle2 = null,
        materielle2 = null,
        estHumaine2 = null,
        humaine2 = null,
        estFinanciere2 = null,
        financiere2 = null,
        estTemoin2 = null,
        temoins2 = null,

        estFait3 = null,
        dateFaits3 = null,
        heureFaits3 = null,
        lieuFaits3 = null,
        fait3 = null,
        missionFait3 = null,
        estMaterielle3 = null,
        materielle3 = null,
        estHumaine3 = null,
        humaine3 = null,
        estFinanciere3 = null,
        financiere3 = null,
        estTemoin3 = null,
        temoins3 = null,

        // fichiers
        photoFile = 2,
        releveVitessesFile = 2,
        factureFile = 2,
        accidentFile = 2,
        mailFile = 2,
        attestationsFile = 2,

        file = [],

        creationDate = null,
        modifDate = null,
        createur = null,

        historique = [],

        salManuel = null,
        cenManuel = null,
        salManagerManuel = null,
        salMailManuel = null,
        salManagerMailManuel = null,
        estSaisieManuelle = false,

        acces = [],

        dateDistributionSanction = null,
        dateDistributionConvoc = null,

        rhDateDepart = null,
        rhEstVisibleReport = true,
        rhComment = null,

        repPers = false
    } = {}) {
        this.id = id
        this.salId = salId
        this.sal = sal ? new Salarie(sal) : null
        this.cenId = cenId
        this.cen = cen ? new Centre(cen) : null
        this.salManagerId = salManagerId
        this.salManager = salManager ? new Salarie(salManager) : null
        this.salDirecteur = salDirecteur ? new Salarie(salDirecteur) : null
        this.affecteeId = affecteeId
        this.affectee = affectee ? new Salarie(affectee) : null
        this.fait = fait
        this.avecMapConserv = avecMapConserv
        this.typeSanEnvisageId = typeSanEnvisageId
        this.typeSanEnvisage = typeSanEnvisage ? new TypeSanction(typeSanEnvisage) : null
        this.numRecConvoc = numRecConvoc
        this.dateEnvoiConvoc = dateEnvoiConvoc ? new Date(dateEnvoiConvoc) : null
        this.datePresentConvoc = datePresentConvoc ? new Date(datePresentConvoc) : null
        this.avecLicenciement = avecLicenciement
        this.dateEntretien = dateEntretien ? new Date(dateEntretien) : null
        this.crDate = crDate ? new Date(crDate) : null
        this.crLieu = crLieu
        this.crFait = crFait
        this.crConsequence = crConsequence
        this.crAReconnu = crAReconnu
        this.crEstAssiste = crEstAssiste
        this.typeSanCrDecisionId = typeSanCrDecisionId
        this.crEnAttente = !!typeSanCrDecisionId
        this.typeSanCrDecision = typeSanCrDecision ? new TypeSanction(typeSanCrDecision) : null
        this.typeSanReelId = typeSanReelId
        this.typeSanReel = typeSanReel ? new TypeSanction(typeSanReel) : null
        this.typeEnvId = typeEnvId
        this.typeEnv = typeEnv ? new TypeEnvoi(typeEnv) : null
        this.dateEnvoiSanction = dateEnvoiSanction ? new Date(dateEnvoiSanction) : null
        this.dateReceptSanction = dateReceptSanction ? new Date(dateReceptSanction) : null
        this.nbJourMap = nbJourMap
        this.estCloture = estCloture
        this.dateCreation = dateCreation ? new Date(dateCreation) : null
        this.origineCreation = origineCreation
        this.dateModif = dateModif ? new Date(dateModif) : null
        this.origineModif = origineModif
        this.etape = etape //TODO ?
        this.crNbJourMap = crNbJourMap
        this.typeEnvConvocId = typeEnvConvocId
        this.typeEnvConvoc = typeEnvConvoc ? new TypeEnvoi(typeEnvConvoc) : null
        this.numRecSanction = numRecSanction
        this.crNomAssistant = crNomAssistant
        this.crPeriodeMap = crPeriodeMap
        this.estAvecDateEnt = estAvecDateEnt
        this.convocComment = convocComment
        this.sancComment = sancComment
        this.dateFaits = dateFaits

        this.procTypeEnvId = procTypeEnvId
        this.entretienAdresse = entretienAdresse
        this.heureFaits = heureFaits
        this.lieuFaits = lieuFaits
        this.missionFait = missionFait
        this.estMaterielle = estMaterielle
        this.materielle = materielle
        this.estHumaine = estHumaine
        this.humaine = humaine
        this.estFinanciere = estFinanciere
        this.financiere = financiere
        this.estTemoin = estTemoin
        this.temoins = temoins

        this.estFait2 = estFait2
        this.dateFaits2 = dateFaits2
        this.heureFaits2 = heureFaits2
        this.lieuFaits2 = lieuFaits2
        this.fait2 = fait2
        this.missionFait2 = missionFait2
        this.estMaterielle2 = estMaterielle2
        this.materielle2 = materielle2
        this.estHumaine2 = estHumaine2
        this.humaine2 = humaine2
        this.estFinanciere2 = estFinanciere2
        this.financiere2 = financiere2
        this.estTemoin2 = estTemoin2
        this.temoins2 = temoins2

        this.estFait3 = estFait3
        this.dateFaits3 = dateFaits3
        this.heureFaits3 = heureFaits3
        this.lieuFaits3 = lieuFaits3
        this.fait3 = fait3
        this.missionFait3 = missionFait3
        this.estMaterielle3 = estMaterielle3
        this.materielle3 = materielle3
        this.estHumaine3 = estHumaine3
        this.humaine3 = humaine3
        this.estFinanciere3 = estFinanciere3
        this.financiere3 = financiere3
        this.estTemoin3 = estTemoin3
        this.temoins3 = temoins3

        this.photoFile = photoFile
        this.releveVitessesFile = releveVitessesFile
        this.factureFile = factureFile
        this.accidentFile = accidentFile
        this.mailFile = mailFile
        this.attestationsFile = attestationsFile


        this.file = (() => {
            if (Array.isArray(file))
                return file?.map(x => new File(x))
            else if (file && typeof file === 'object')
                return [new File(file)]
            else
                return []
        })()

        this.creationDate = creationDate ? new Date(creationDate) : null
        this.modifDate = modifDate ? new Date(modifDate) : null
        this.createur = createur //TODO ?

        this.historique = (() => {
            if (Array.isArray(historique))
                return historique?.map(x => new Historique(x))
            else if (historique && typeof historique === 'object')
                return [new Historique(historique)]
            else
                return []
        })()

        this.salManuel = salManuel
        this.cenManuel = cenManuel
        this.salManagerManuel = salManagerManuel
        this.salMailManuel = salMailManuel
        this.salManagerMailManuel = salManagerMailManuel
        this.estSaisieManuelle = estSaisieManuelle

        this.acces = acces
        this.hasAccess = {
            readProc: !!acces?.find(x => x.libelle === "READ_PROC")?.aAcces ?? false,
            ecritureGeneralProc: !!acces?.find(x => x.libelle === "ECRITURE_GENERAL_PROC")?.aAcces ?? false,
            ecritureConvocationProc: !!acces?.find(x => x.libelle === "ECRITURE_CONVOCATION_PROC")?.aAcces ?? false,
            ecritureEentretienProc: !!acces?.find(x => x.libelle === "ECRITURE_ENTRETIEN_PROC")?.aAcces ?? false,
            ecritureSanctionProc: !!acces?.find(x => x.libelle === "ECRITURE_SANCTION_PROC")?.aAcces ?? false,
            ecritureJustificatifProc: !!acces?.find(x => x.libelle === "ECRITURE_JUSTIFICATIF_PROC")?.aAcces ?? false,
            ecritureAffecteAProc: !!acces?.find(x => x.libelle === "ECRITURE_AFEFCTE_A_PROC")?.aAcces ?? false,
            suppressionProc: !!acces?.find(x => x.libelle === "SUPPRESSION_PROC")?.aAcces ?? false,
            ecritureManuelleProc: !!acces?.find(x => x.libelle === "ECRITURE_MANUELLE_PROC")?.aAcces ?? false,
            cloturerProc: !!acces?.find(x => x.libelle === "CLOTURER_PROC")?.aAcces ?? false,
            validerProc: !!acces?.find(x => x.libelle === "VALIDER_PROC")?.aAcces ?? false,
            ecritureRhProc: !!acces?.find(x => x.libelle === "ECRITURE_RH_PROC")?.aAcces ?? false,
        }

        this.dateDistributionSanction = dateDistributionSanction ? new Date(dateDistributionSanction) : null
        this.dateDistributionConvoc = dateDistributionConvoc ? new Date(dateDistributionConvoc) : null

        this.rhDateDepart = rhDateDepart ? new Date(rhDateDepart) : null
        this.rhEstVisibleReport = !!rhEstVisibleReport
        this.rhComment = rhComment

        this.repPers = repPers
    }
}

/**
 * Procedure Object used to bind error message
 */
export class ErrorProcedure {
    id
    salId
    sal
    cenId
    cen
    salManagerId
    salManager
    affecteeId
    affectee
    fait
    avecMapConserv
    typeSanEnvisageId
    typeSanEnvisage
    numRecConvoc
    dateEnvoiConvoc
    datePresentConvoc
    avecLicenciement
    dateEntretien
    crDate
    crLieu
    crFait
    crConsequence
    crAReconnu
    crEstAssiste
    typeSanCrDecisionId
    typeSanCrDecision
    typeSanReelId
    typeSanReel
    typeEnvId
    typeEnv
    dateEnvoiSanction
    dateReceptSanction
    nbJourMap
    estCloture
    dateCreation
    origineCreation
    dateModif
    origineModif
    etape
    crNbJourMap
    typeEnvConvocId
    typeEnvConvoc
    numRecSanction
    crNomAssistant
    crPeriodeMap
    estAvecDateEnt
    convocComment
    sancComment
    dateFaits

    procTypeEnvId
    entretienAdresse
    heureFaits
    lieuFaits
    missionFait
    estMaterielle
    materielle
    estHumaine
    humaine
    estFinanciere
    financiere
    estTemoin
    temoins

    estFait2
    dateFaits2
    heureFaits2
    lieuFaits2
    fait2
    missionFait2
    estMaterielle2
    materielle2
    estHumaine2
    humaine2
    estFinanciere2
    financiere2
    estTemoin2
    temoins2

    estFait3
    dateFaits3
    heureFaits3
    lieuFaits3
    fait3
    missionFait3
    estMaterielle3
    materielle3
    estHumaine3
    humaine3
    estFinanciere3
    financiere3
    estTemoin3
    temoins3

    photoFile
    releveVitessesFile
    factureFile
    accidentFile
    mailFile
    attestationsFile

    creationDate
    modifDate
    createur
    salManuel
    cenManuel
    salManagerManuel
    salMailManuel
    salManagerMailManuel
    estSaisieManuelle

    dateDistributionSanction
    dateDistributionConvoc

    rhDateDepart
    rhEstVisibleReport
    rhComment
}